import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useHistory } from "react-router-dom";
import { getProperty } from "../../services/properties";
import { ROUTES } from "../../constants";
import { getPropertyUnit } from "../../services/units";

function Invite({ invite, listing = undefined }) {
  const history = useHistory();
  const [property, setProperty] = useState();
  const [unit, setUnit] = useState();

  useEffect(() => {
    if (invite) {
      getProperty(invite.propertyId).then((response) => {
        setProperty(response);
      });
      getPropertyUnit(invite.propertyId, invite.unitId).then((response) => {
        setUnit(response);
      });
    }
  }, [invite]);

  const onClickStart = () => {
    debugger;
    if (listing && listing?.id) {
      history.push(`${ROUTES.PRIVATE_LISTINGS}/${listing?.id}`);
    } else {
      history.push(`/add-listing/${invite.propertyId}/unit/${invite.unitId}`);
    }
  };

  if (!unit || !property) {
    return null;
  }

  return (
    <Paper
      className="tenant"
      sx={{
        marginBottom: {
          xs: "1rem",
        },
      }}
    >
      <Grid item xs={12}>
        <Box
          sx={{
            padding: {
              xs: "2rem",
            },
          }}
        >
          <p>Welcome {invite?.firstName},</p>
          <p>
            You've been invited to join to complete a properties order to list
            your current unit.
          </p>
          <p>List your apartment today, and you can earn up to $250!</p>
          <Box
            sx={{
              backgroundColor: "rgba(48, 139, 90, .1)",
              padding: "1rem",
              fontSize: "1rem",
              color: "rgba(0, 0, 0, 1)",
              display: {
                sm: "flex",
              },
              flexDirection: "row",
            }}
          >
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M53.6667 56C54.2855 56 54.879 55.7542 55.3166 55.3166C55.7542 54.879 56 54.2855 56 53.6667C56 53.3572 55.8771 53.0605 55.6583 52.8417C55.4395 52.6229 55.1427 52.5 54.8333 52.5H33.8333C33.5239 52.5 33.2272 52.3771 33.0084 52.1583C32.7896 51.9395 32.6667 51.6427 32.6667 51.3333C32.6667 51.0239 32.7896 50.7272 33.0084 50.5084C33.2272 50.2896 33.5239 50.1667 33.8333 50.1667H54.8333C55.1427 50.1667 55.4395 50.0438 55.6583 49.825C55.8771 49.6062 56 49.3094 56 49V47.8333C56 47.5239 55.8771 47.2272 55.6583 47.0084C55.4395 46.7896 55.1427 46.6667 54.8333 46.6667H33.8333C33.5239 46.6667 33.2272 46.5438 33.0084 46.325C32.7896 46.1062 32.6667 45.8094 32.6667 45.5C32.6667 45.1906 32.7896 44.8938 33.0084 44.675C33.2272 44.4562 33.5239 44.3333 33.8333 44.3333H54.8333C55.1427 44.3333 55.4395 44.2104 55.6583 43.9916C55.8771 43.7728 56 43.4761 56 43.1667V42C56 41.7952 55.9461 41.594 55.8437 41.4167C55.7413 41.2393 55.594 41.0921 55.4167 40.9897C55.239 40.8871 55.0915 40.7394 54.9891 40.5616C54.8866 40.3838 54.8329 40.1822 54.8333 39.977V2.33333C54.8333 1.71449 54.5875 1.121 54.1499 0.683417C53.7123 0.245833 53.1188 0 52.5 0L37.3333 0C37.0239 0 36.7272 0.122916 36.5084 0.341709C36.2896 0.560501 36.1667 0.857247 36.1667 1.16667V39.6667C36.1667 39.9761 36.0438 40.2728 35.825 40.4916C35.6062 40.7104 35.3094 40.8333 35 40.8333H33.8333C33.5239 40.8333 33.2272 40.7104 33.0084 40.4916C32.7896 40.2728 32.6667 39.9761 32.6667 39.6667V1.16667C32.6667 0.857247 32.5438 0.560501 32.325 0.341709C32.1062 0.122916 31.8094 0 31.5 0L3.5 0C2.57174 0 1.6815 0.368749 1.02513 1.02513C0.368749 1.6815 0 2.57174 0 3.5L0 52.5C0 53.4283 0.368749 54.3185 1.02513 54.9749C1.6815 55.6312 2.57174 56 3.5 56H53.6667ZM45.5 5.83333C46.423 5.83333 47.3252 6.10703 48.0927 6.61981C48.8601 7.13259 49.4582 7.86142 49.8114 8.71414C50.1646 9.56687 50.2571 10.5052 50.077 11.4104C49.8969 12.3157 49.4525 13.1472 48.7998 13.7998C48.1472 14.4525 47.3157 14.8969 46.4104 15.077C45.5052 15.2571 44.5669 15.1646 43.7141 14.8114C42.8614 14.4582 42.1326 13.8601 41.6198 13.0927C41.107 12.3252 40.8333 11.423 40.8333 10.5C40.8333 9.26232 41.325 8.07534 42.2002 7.20017C43.0753 6.325 44.2623 5.83333 45.5 5.83333ZM40.8333 33.8333C40.8333 32.5957 41.325 31.4087 42.2002 30.5335C43.0753 29.6583 44.2623 29.1667 45.5 29.1667C46.7377 29.1667 47.9247 29.6583 48.7998 30.5335C49.675 31.4087 50.1667 32.5957 50.1667 33.8333V39.6667C50.1667 39.9761 50.0438 40.2728 49.825 40.4916C49.6062 40.7104 49.3094 40.8333 49 40.8333H42C41.6906 40.8333 41.3938 40.7104 41.175 40.4916C40.9562 40.2728 40.8333 39.9761 40.8333 39.6667V33.8333ZM12.8333 44.3333C12.8333 44.6427 12.7104 44.9395 12.4916 45.1583C12.2728 45.3771 11.9761 45.5 11.6667 45.5H5.83333C5.52391 45.5 5.22717 45.3771 5.00838 45.1583C4.78958 44.9395 4.66667 44.6427 4.66667 44.3333V36.75C4.66667 35.667 5.09687 34.6284 5.86265 33.8626C6.62842 33.0969 7.66703 32.6667 8.75 32.6667C9.83297 32.6667 10.8716 33.0969 11.6374 33.8626C12.4031 34.6284 12.8333 35.667 12.8333 36.75V44.3333ZM12.8333 21C12.8333 21.3094 12.7104 21.6062 12.4916 21.825C12.2728 22.0438 11.9761 22.1667 11.6667 22.1667H5.83333C5.52391 22.1667 5.22717 22.0438 5.00838 21.825C4.78958 21.6062 4.66667 21.3094 4.66667 21V13.4167C4.66667 12.3337 5.09687 11.2951 5.86265 10.5293C6.62842 9.76354 7.66703 9.33333 8.75 9.33333C9.83297 9.33333 10.8716 9.76354 11.6374 10.5293C12.4031 11.2951 12.8333 12.3337 12.8333 13.4167V21ZM28 44.3333C28 44.6427 27.8771 44.9395 27.6583 45.1583C27.4395 45.3771 27.1428 45.5 26.8333 45.5H21C20.6906 45.5 20.3938 45.3771 20.175 45.1583C19.9562 44.9395 19.8333 44.6427 19.8333 44.3333V36.75C19.8333 35.667 20.2635 34.6284 21.0293 33.8626C21.7951 33.0969 22.8337 32.6667 23.9167 32.6667C24.9996 32.6667 26.0382 33.0969 26.804 33.8626C27.5698 34.6284 28 35.667 28 36.75V44.3333ZM28 21C28 21.3094 27.8771 21.6062 27.6583 21.825C27.4395 22.0438 27.1428 22.1667 26.8333 22.1667H21C20.6906 22.1667 20.3938 22.0438 20.175 21.825C19.9562 21.6062 19.8333 21.3094 19.8333 21V13.4167C19.8333 12.3337 20.2635 11.2951 21.0293 10.5293C21.7951 9.76354 22.8337 9.33333 23.9167 9.33333C24.9996 9.33333 26.0382 9.76354 26.804 10.5293C27.5698 11.2951 28 12.3337 28 13.4167V21Z"
                fill="#308B5A"
              />
            </svg>
            <p style={{ marginLeft: "1rem" }}>
              {property.address.street}, {property.address.city},{" "}
              {property.address.subdivision}, {property.address.country},{" "}
              {property.address.postalCode}
            </p>
          </Box>
        </Box>
        <Box
          sx={{
            padding: {
              xs: "0 2rem 2rem 2rem",
            },
            display: {
              sm: "flex",
            },
            flexDirection: "row",
            justifyContent: "right",
          }}
        >
          <Button size="small" variant="contained" onClick={onClickStart}>
            Start
          </Button>
        </Box>
      </Grid>
    </Paper>
  );
}

export default Invite;
